export default "__VITE_ASSET__xk3B0DQw__"